
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const login = Yup.object().shape({
      email: Yup.string().email().required().label("Email"),
      password: Yup.string().min(4).required().label("Contraseña"),
    });

    //Form submit function
    const onSubmitLogin = (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
      }

      // Dummy delay
      setTimeout(() => {
        // Send login request
        console.log(values);
        store
          .dispatch(Actions.LOGIN, {
            correo: values.email,
            clave: values.password,
          })
          .then(() => {
            store.dispatch(Actions.VERIFY_AUTH);
            Swal.fire({
              text: "¡Has iniciado sesión correctamente!",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ingresar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            }).then(function () {
              // Go to page after successfully login
              router.push({ name: "inicio" });
            });
          })
          .catch(() => {
            const { message, statusCode } = store.getters.getErrors;
            Swal.fire({
              /*title: error,*/
              text: `[${statusCode ?? "Error"}] ${message}`,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "¡Inténtalo de nuevo!",
              customClass: {
                confirmButton: "btn fw-bold btn-light-danger",
              },
            });
          });
        //Deactivate indicator
        submitButton.value?.removeAttribute("data-kt-indicator");
      }, 2000);
    };

    return {
      onSubmitLogin,
      login,
      submitButton,
    };
  },
});
